import { InjectionToken } from '@angular/core';

/**
 * Injectable token for the browser's Window object, enabling services
 * and components to access window.location, window.history, etc.
 * without a direct global reference. This makes the code testable
 * because tests can provide a mock Window without patching globals.
 */
export const WINDOW = new InjectionToken<Window>('Window', {
  providedIn: 'root',
  factory: () => window
});
